import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Kode } from '../Utils'
import axiosJWT from '../JwtToken'

export const Add = ({ requestCode, potensialCode, potensialName, closeAdd, getPesan, setMsg }) => {

  const [contactName, setContactName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
  const [nilaiPenawaran, setNilaiPenawaran] = useState('')
  const [information, setInformation] = useState('')
  const [file, setFile] = useState("")
  const [preview, setPreview] = useState("")
  const navigate = useNavigate()

  const loadFile = (e) => {
    const file = e.target.files[0]
    setFile(file)
    setPreview(URL.createObjectURL(file))
  }

  const proses = async (e) => {
    e.preventDefault()

    if (file && file.size > 50 * 1024 * 1024) {
      setMsg('Ukuran file proposal (Maksimal 50 MB)!')
      return
    }

    try {
      const formData = new FormData()

      // Set nomor permohonan pake format generator custom lu bray
      const nomorPermohonanUnik = `REQ-${Kode()}`

      formData.append("code", nomorPermohonanUnik)
      formData.append("requestCode", requestCode)
      formData.append("potensialCode", potensialCode)
      formData.append("potensialName", potensialName)
      formData.append("contactName", contactName)
      formData.append("phoneNumber", phoneNumber)
      formData.append("email", email)
      formData.append("nilaiPenawaran", nilaiPenawaran)
      formData.append("information", information)
      formData.append("file", file)

      await axiosJWT.post('/api/request-procurement', formData)

      getPesan()
      setMsg("Permintaan pengadaan berhasil disimpan!")

      setTimeout(() => {
        getPesan()
        setMsg('')
        closeAdd()
      }, 2000)
    } catch (err) {
      getPesan()
      const errorMsg = (err.response && err.response.data && err.response.data.msg)
        ? err.response.data.msg
        : 'Maaf, proses pengiriman data gagal!'
      setMsg(errorMsg)
      setTimeout(() => {
        getPesan()
        setMsg('')
      }, 4000)
    }
  }

  return (<>
    <form onSubmit={proses} className="form-horizontal">
      <h5 className="right-line color-success">Pengajuan Penawaran</h5>
      <div className="row">
        <div className="form-group col-md-6">
          <div className="row">

            {/* 🌟 FORM KEGIATAN USAHA LANGSUNG INPUT READONLY TOTAL, ANTI REPOT BRAY! */}
            <div className="form-group col-md-12">
              <label className="control-label">Kegiatan Usaha</label>
              <div className="input-group">
                <span className="input-group-addon"><i className="fa fa-briefcase"></i></span>
                <input
                  type="text"
                  className="form-control"
                  value={potensialName}
                  readOnly
                  style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed', fontWeight: 'bold' }}
                  required
                />
              </div>
            </div>

            <div className="form-group col-md-12">
              <label className="control-label">Nama Pemohon</label>
              <div className="input-group">
                <span className="input-group-addon"><i className="fa fa-user"></i></span>
                <input type="text" className="form-control" onChange={(e) => setContactName(e.target.value)} value={contactName} required />
              </div>
            </div>
            <div className="form-group col-md-12">
              <label className="control-label">Nilai Penawaran</label>
              <div className="input-group">
                <span className="input-group-addon"><i className="fa fa-money"></i></span>
                <input type="number" className="form-control" onChange={(e) => setNilaiPenawaran(e.target.value)} value={nilaiPenawaran} required />
              </div>
            </div>
          </div>
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">File Pendukung</label>
          {preview ? (<iframe width="100%" height="200" src={preview} title="Preview File" />) : (<img width="100%" height="200" src="/assets/img/no-image.png" title="Preview File" alt="Preview File" />)}
          <input className="form-control mt-2" type="file" onChange={loadFile} accept=".pdf" required />
          <span className="badge d-inline-block text-wrap badge-danger mt-1">Upload file persyaratan menjadi 1 file dengan ekstensi .PDF</span>
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">No. Hp</label>
          <div className="input-group">
            <span className="input-group-addon"><i className="fa fa-phone"></i></span>
            <input type="number" className="form-control" onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber} required />
          </div>
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">Email</label>
          <div className="input-group">
            <span className="input-group-addon"><i className="fa fa-envelope"></i></span>
            <input type="email" className="form-control" onChange={(e) => setEmail(e.target.value)} value={email} required />
          </div>
        </div>

        <div className="form-group col-md-12">
          <label className="control-label">Informasi</label>
          <div className="input-group">
            <span className="input-group-addon"><i className="fa fa-text"></i></span>
            <textarea className="form-control" onChange={(e) => setInformation(e.target.value)} value={information} required></textarea>
          </div>
        </div>
      </div>
      <div className="modal-footer px-0 pb-0 mt-3">
        <button className="btn btn-raised btn-primary br-2 no-m mr-2" type="Submit"><i className="fa fa-save"></i> Simpan</button>
        <button type="button" onClick={closeAdd} className="btn btn-raised btn-danger br-2 no-m">
          <i className="fa fa-sign-out"></i> Tutup
        </button>
      </div>
    </form>
  </>)
}